import React from "react";
import GenericPullConfigListing from "../GenericPullConfigListing";
import PrivadoMappingForm from "./PrivadoMappingForm";
import PrivadoCredentialsForm from "./PrivadoCredentialsForm";

export default function PrivadoConfigListing(props){
    return (
        <GenericPullConfigListing 
            {...props}
            toolName={props.name}
            MappingForm={PrivadoMappingForm}
            CredentialsForm={PrivadoCredentialsForm}
            componentName="Repository Name"
            componentKey="repositoryName"

        />
    )
}